import axios from 'axios';

export const AttachChildApi = {
  loadRequests: filter => axios.get(`/api/public/child_connection_form?filter=${filter}`),
  approveRequest: id => axios.put(`/api/public/child_connection_form/${id}/approve`),
  declineRequest: (id, comment) =>
    axios.put(`/api/public/child_connection_form/${id}/decline`, comment)
};
